<template>
  <div class="model_container modelTab">
    <el-form label-position="top">
      <el-form-item label="搜索类型">
        <el-radio-group @change="initSearchOption" v-model="modelType" size="small">
          <el-radio-button label="STOCK">股票</el-radio-button>
          <el-radio-button label="STOCK_GROUP">股票组</el-radio-button>
          <el-radio-button label="CONCEPT">概念</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" v-if="modelType === 'STOCK'">
        <el-select @change="getModels" v-model="curSymbol" filterable :remote="true" :remote-method="searchStockOption"
          :popper-append-to-body="false" placeholder="搜索股票">
          <el-option v-for="(item, index) in stockCaditionOption" :key="index" :label="item.name"
            :value="item.code"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="" v-if="modelType === 'STOCK_GROUP'">
        <div class="my-group-select">
          <el-select class="right-select" v-model="curSymbols" :multiple="true" filterable
            :filter-method="searchStockGroupOption" :popper-append-to-body="false" placeholder="搜索股票">
            <el-option v-for="(item, index) in stockGroupCaditionOption" :key="index" :label="item.name"
              :disabled="curSymbols.length > 4 && curSymbols.indexOf(item.code) === -1" :value="item.code"></el-option>
          </el-select>
          <el-button class="right-button" type="primary" @click="getModels"
            :disabled="curSymbols.length < 2">搜索</el-button>
        </div>
      </el-form-item>

      <el-form-item label="" v-if="modelType === 'CONCEPT'">
        <el-select @change="getModels" v-model="curConcept" filterable :filter-method="searchConceptOption"
          :popper-append-to-body="false" placeholder="搜索概念">
          <el-option v-for="(item, index) in conceptCaditionOption" :key="index" :label="item.name"
            :value="item.code"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="搜索模块">
        <el-select class="modelType-select" v-model="searchModelName" filterable :filter-method="searchModel"
          @change="previewByIndex(searchModelName)" :popper-append-to-body="false" placeholder="搜索模块" clearable
          @clear="modelOption = []">
          <el-option v-for="(item, index) in modelOption" :key="item.moduleName" :label="item.moduleName"
            :value="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模块">
        <el-radio-group v-model="childTab" class="model_tab" style="line-height: 50px;" size="mini">
          <el-radio-button label="全部">全部</el-radio-button>
          <el-radio-button v-for="(v, k) of  modelData" :key="k" :label="k" size="small"></el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="scrollContainer" style="overflow-y: scroll;height: calc(100vh - 435px); margin-top: 10px;"
      v-loading="modelLoading" element-loading-text="模块加载中">
      <div class="list">
        <template v-if="!isEmptyObj(modelData)">
          <div v-for="(v, k) of  modelData" :key="k">
            <template v-for="(item, index) in v">
              <template v-if="k === childTab || childTab === '全部'">

                <el-card :key="index" shadow="hover" class="article_card">
                  <div class="title">
                    <span :class="'tag ' + item.tag">{{ item.tag }}</span>
                    {{ item.moduleName }}
                  </div>
                  <div class="opreate">
                    <el-link :underline="false" @click="preview(item)">
                      <span class="link"> 数据预览</span>
                    </el-link>
                    <el-link :underline="false" @click="insert(item.moduleHtml)">
                      <span class="link"> 插入正文</span>
                    </el-link>
                  </div>
                </el-card>

              </template>
            </template>

          </div>
        </template>
        <template v-else>
          <template v-if="!modelLoading">
            <br><br><br>
            <img src="../../assets/imgs/finance-model-empty.png" alt="" width="40%" class="image">
            <div class="emptyDesc">
              【模块库】已内置大量专业财经数据模块<br />
              可直接使用
            </div>
          </template>
        </template>
      </div>
      <div style="clear:both"></div>
    </div>

    <el-dialog :append-to-body='true' :show-close=true width="800px" :visible.sync="previewDialogVisible"
      custom-class="previewDialog">
      <span slot="title">
        <h4>{{ curModel.moduleName }}</h4>
        <div class="summary">{{ curModel.funSummary }}</div>
      </span>

      <div class="bgContainer">
        <div class="htmlContainer" v-html="curModel.moduleHtml">
        </div>
      </div>
      <span slot="footer">
        <div class="previewFooter">
          <span>数据来源：<a href="http://www.csmar.com/" target="_blank">CSMAR</a></span>
          <span style="width: 500px;height: 10px;display: inline-block;">&nbsp;</span>
          <el-button size="mini" type="primary" style="margin-right: 0;"
            @click="insert(curModel.moduleHtml)">插入正文</el-button>
        </div>

      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: ['code'],
  components: {
  },
  name: 'bindMobile',
  data: function () {
    return {
      modelType: 'STOCK',
      curSymbol: '',
      curSymbols: [],
      curConcept: '',
      stockCaditionOption: [],
      stockGroupCaditionOption: [],
      conceptCaditionOption: [],
      stockList: [],
      childTab: '全部',
      modelData: {},
      modelOption: [],
      modelLoading: true,
      previewDialogVisible: false,
      curModel: {},
      searchModelName: '',
      conceptMap: {},
      stockMap: {},
      compareMap: {},
      curTest: ''
    }
  },
  metaInfo () {
    return {
      title: '弈写AI辅助写作'
    }
  },
  methods: {
    searchModel (key) {
      console.log('搜索模块', key)
      this.modelOption = []
      if (this.modelData) {
        for (let k in this.modelData) {
          for (let v of this.modelData[k]) {
            if (v.moduleName.indexOf(key) > -1) {
              this.modelOption.push(v)
            }
            if (this.modelOption.length > 4) {
              return
            }
          }
        }
      }
    },

    initSearchOption () {
      this.modelData = []
      this.modelOption = []
      this.searchModelName = ''
      this.getModels()
    },
    isEmptyObj (val) {
      if (!val) {
        return true
      }
      for (let item in val) {
        return false
      }
      return true
    },
    previewByIndex (index) {
      this.preview(this.modelOption[index])
    },
    preview (val) {
      if (val) {
        this.curModel = val
        this.previewDialogVisible = true
      }
    },
    insert (val) {
      this.previewDialogVisible = false
      this.$emit('insert', val)
    },
    searchStockOption (key) {
      console.log('搜索股票', key)
      key = key.toUpperCase()
      this.stockCaditionOption = []
      for (let stock of this.stockList) {
        if (this.stockCaditionOption.length > 4) {
          break
        }
        if ((stock.symbol.indexOf(key) > -1 ||
          stock.name.indexOf(key) > -1 ||
          stock.pinyin.indexOf(key) > -1)) {
          this.stockCaditionOption.push({ 'name': stock.name, 'code': stock.symbol })
        }
      }
    },
    searchStockGroupOption (key) {
      console.log('搜索股票', key)
      console.log(this.curSymbols)
      key = key.toUpperCase()
      let temp = []
      this.stockGroupCaditionOption = []
      for (let stock of this.stockList) {
        if (this.stockGroupCaditionOption.length > 4) {
          break
        }
        if ((stock.symbol.indexOf(key) > -1 ||
          stock.name.indexOf(key) > -1 ||
          stock.pinyin.indexOf(key) > -1) && this.curSymbols.indexOf(stock.symbol) === -1) {
          this.stockGroupCaditionOption.push({ 'name': stock.name, 'code': stock.symbol, 'show': true })
          temp.push(stock.symbol)
        }
      }
      for (let stock of this.stockList) {
        if (this.curSymbols.indexOf(stock.symbol) > -1 && temp.indexOf(stock.symbol) === -1) {
          this.stockGroupCaditionOption.push({ 'name': stock.name, 'code': stock.symbol, 'show': false })
        }
      }
    },
    searchConceptOption (key) {
      this.caditionOption = []
      console.log(key)
      key = key.toUpperCase()
      for (let concept of this.conceptList) {
        if (this.conceptCaditionOption.length > 4) {
          break
        }
        if (concept.bk_code.indexOf(key) > -1 ||
          concept.bk_name.indexOf(key) > -1
        ) {
          this.conceptCaditionOption.push({ 'name': concept.bk_name, 'code': concept.bk_code })
        }
      }
    },
    getModels () {
      this.modelData = []
      let _this = this
      if (this.modelType === 'CONCEPT') {
        if (!this.curConcept) {
          return
        }
        if (this.conceptMap[this.curConcept]) {
          this.modelData = this.conceptMap[this.curConcept]
          return
        }
        this.modelLoading = true
        this.axios.get(`/webApi/v3/finace/module/concept?code=${this.curConcept}`).then(resp => {
          _this.modelData = resp.data
          _this.conceptMap[_this.curConcept] = _this.modelData
          _this.modelLoading = false
        })
      } else if (this.modelType === 'STOCK') {
        if (!this.curSymbol) {
          return
        }
        if (this.stockMap[this.curSymbol]) {
          this.modelData = this.stockMap[this.curSymbol]
          return
        }
        this.modelLoading = true
        this.axios.get(`/webApi/v3/finace/module/simple?code=${this.curSymbol}`).then(resp => {
          _this.modelData = resp.data
          _this.stockMap[_this.curSymbol] = _this.modelData
          _this.modelLoading = false
        })
      } else {
        if (this.curSymbols.length < 2) {
          return
        }
        let code = this.curSymbols.join(',')
        if (!code) {
          return
        }
        if (this.compareMap[code]) {
          this.modelData = this.compareMap[code]
          return
        }
        this.modelLoading = true
        this.axios.get(`/webApi/v3/finace/module/portfolio?stockCodes=${this.curSymbols.join(',')}`).then(resp => {
          _this.modelData = resp.data
          _this.compareMap[code] = _this.modelData
          _this.modelLoading = false
        })
      }
    }
  },
  computed: {

  },
  watch: {

  },
  mounted () {
    let _this = this
    if (this.code) {
      if (this.code.indexOf(',') > -1) {
        this.modelType = 'STOCK_GROUP'
      } else if (this.code.toUpperCase().indexOf('BK') > -1) {
        this.modelType = 'CONCEPT'
      }
    } else {
      this.modelLoading = false
    }

    this.axios.get('/webApi/v3/finace/all_stock_list_basic_data').then(resp => {
      _this.stockList = resp.data
      if (_this.code) {
        for (let item of _this.stockList) {
          if (_this.code.indexOf(item.symbol) > -1) {
            _this.stockCaditionOption.push({ 'name': item.name, 'code': item.symbol })
            _this.stockGroupCaditionOption.push({ 'name': item.name, 'code': item.symbol })
          }
        }
      }
      if (this.code.indexOf(',') > -1) {
        _this.curSymbols = this.code.split(',')
        this.getModels()
      } else if (_this.code.toUpperCase().indexOf('BK') === -1) {
        _this.curSymbol = this.code
        this.getModels()
      }
    })
    this.axios.get('/webApi/v3/finace/api_concept_list_info').then(resp => {
      _this.conceptList = resp.data
      if (_this.code) {
        for (let concept of _this.conceptList) {
          if (concept.bk_code === _this.code) {
            _this.conceptCaditionOption.push({ 'name': concept.bk_name, 'code': concept.bk_code })
            break
          }
        }
      }
      if (_this.code.toUpperCase().indexOf('BK') > -1) {
        _this.curConcept = _this.code
        _this.getModels()
      }
    })
  }
}

</script>
<style lang="less">
.modelType-select {
  .el-select-dropdown {
    border: none;
    box-shadow: none;
  }

  .el-select-dropdown__item {
    color: #666;
  }
}

.my-group-select {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding-left: 3px;

  .right-select {
    width: calc(100% - 40px) !important;
    left: -3px;
    display: inline-block;

    .el-tag {
      width: 60px;
      padding: 3px;
    }

    input {
      border-radius: 10px;
      border: none;
    }
  }

  .right-button {
    height: 100%;
    margin-right: 0;
    box-sizing: border-box;
    width: 46px;
    right: 0px;
    position: absolute;
    border: none;
    font-size: 12px;
    padding: 12px 10px;
    border-radius: 0px 4px 4px 0px;
  }
}

.model_tab {
  line-height: 50px;

  .el-radio-button__inner {
    padding: 10px 12px !important;
  }
}
</style>

<style lang="less" scoped>
.previewFooter {
  color: #999999;
  font-size: 13px;
  text-align: left;
}

.modelTab {
  .list {
    .emptyDesc {
      color: rgba(187, 197, 213, 0.59);
      width: 90%;
      margin: auto;
    }

    .item {
      text-align: left;
      padding: 10px;

      .title {
        font-size: 14px;
      }

      .tag {
        font-size: 12px;
        color: white;
        background-color: #999;
        padding: 3px;
        border-radius: 3px;
      }

      .图文 {
        background-color: #e99191;
      }

      .表格 {
        background-color: #33c8bd;
      }

      .图片 {
        background-color: #946dee;
      }

      .文本 {
        background-color: #559be9;
      }
    }

    .opreate {
      text-align: right;

      .link {
        color: #4b8cf7;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/article/modelTab.vue